import { Connection } from './connection';
import { Connector } from './connector';
import { CoordinatorService } from './coordinator.service';
import { Databin } from './databin';
import { ScriptArchivedSearch } from './script-archived-search';
import { ScriptDatabin } from './script-databin';
import { ScriptHitset } from './script-hitset';
import { ScriptOverlap } from './script-overlap';
import { ScriptResource } from './script-resource';
import { ScriptSubset } from './script-subset';
import { Search } from './search';
import { STG } from './stage';
import { View } from './view';

export class Overlap$ {
    private _hitsetMap = new Map<string, ScriptHitset>();
    private _overlapMap = new Map<string, ScriptOverlap>();
    private _lastHitsetParent: any;
    private _uniqueSet?: ScriptHitset;
    private _main?: ScriptHitset;

    private _enabledSet = new Set(['subsets', 'databins']);
    // private _enabledSet = new Set(['searches']);

    enableTagLs: string[] = ['subsets', 'databins', 'resources', 'Hitsets'];

    constructor(public coords: CoordinatorService) {
        // this._selectedSet.add("view-main")
    }

    async init() {
        this._hitsetMap.clear();
        this._overlapMap.clear();
        this._initSubsets();
        this._initDatabins();
        this._initConnections();
        this._initSearches();
    }

    isEnabled(tag: string) {
        return this._enabledSet.has(tag);
    }

    setEnabled(tag: string, isOn = true) {
        if (isOn) this._enabledSet.add(tag);
        else this._enabledSet.delete(tag);
    }

    fieldLs(h: ScriptHitset) {
        const main = this._main!;
        const ls: { size: number; preview: () => void; title: string }[] = [];
        if (h === main) {
            h.payload = { icon: 'overlap_size' };
            ls.push(h.field('overlap_field_size', true));
            let tp: string;
            if (main.parent instanceof ScriptSubset) tp = 'subset';
            else if (main.parent instanceof ScriptDatabin) tp = 'databin';
            else if (main.parent instanceof ScriptResource) tp = 'connection';
            else if (main.parent instanceof ScriptArchivedSearch) tp = 'search';
            else console.log(main.parent);
            ls.push(this._uniqueSet!.field(`overlap_field_uniqueIn-${tp!}`));
            return ls;
        }

        const o = this._overlapMap.get(`${main.id}_${h.id}`)!;
        if (!o) return ls;
        for (const t of ['size', 'overlap', 'only', 'missing']) {
            const f = o.field(t as any, h);
            if (!f) return ls;
            ls.push(f);
        }

        return ls;
    }
    private _setOverlap(orig: ScriptHitset, target: ScriptHitset) {
        if (this._overlapMap.has(`${orig.id}_${target.id}`)) return;
        const o = new ScriptOverlap(this.coords, orig, target);
        console.log(o.calcDistribution());

        this._overlapMap.set(o.key(), o);
        this._overlapMap.set(o.key(true), o);
    }

    async initMain(value?: ScriptHitset) {
        if (!value) {
            if (this._lastHitsetParent) {
                for (const h of this._hitsetMap.values()) {
                    if (h.parent?.id === this._lastHitsetParent?.id) {
                        value = h;
                        break;
                    }
                }
            }
            if (!value) value = this._hitsetMap.values().next().value;
        }

        const main: ScriptHitset = value!;
        if (!main) return;

        this._uniqueSet = main.clone();
        this._uniqueSet.payload = { icon: 'overlap_unique' };
        this._main = main;
        const otherLs: ScriptHitset[] = Array.from(this._hitsetMap.values()).filter(
            (h: ScriptHitset) => h !== main,
        );
        this._lastHitsetParent = main.parent;

        otherLs.forEach((h: ScriptHitset) => {
            this._setOverlap(main, h);
            if (h.parent?.constructor === main.parent?.constructor)
                h.idSet.forEach((id: string) => this._uniqueSet!.idSet.delete(id));
        });
        return { main, otherLs };
    }

    private _initSubsets() {
        if (!this._enabledSet.has('subsets')) return;

        this.coords.view$.sortedViewLs.forEach((v: View) => {
            const h = v.scriptClass.hitset();
            this._hitsetMap.set(h.id, h);
        });
    }

    private _initDatabins() {
        if (!this._enabledSet.has('databins')) return;
        this.coords.databin$.sortedDatabinLs.forEach((d: Databin) => {
            if (!d.isOn) return;
            const h = d.scriptClass.hitset(true);
            this._hitsetMap.set(h.id, h);
        });
    }

    private _initConnections() {
        if (!this._enabledSet.has('resources')) return;
        this.coords.databin$.sortedDatabinLs.forEach((d: Databin) => {
            if (!d.isOn) return;
            d.connectionLs.forEach((c: Connection) => {
                if (!c.isOn) return;
                const h = c.scriptClass.hitset(true);
                this._hitsetMap.set(h.id, h);
            });
        });
    }

    private _initSearches() {
        if (!this._enabledSet.has('searches')) return;
        this.coords.searchArchive$.searchLs().forEach((s) => {
            let h = this.coords.searchArchive$.getCacheHitset(s.id);

            h = s.run();

            if (!h) return;
            h.parent = s.scriptClass;

            this.coords.searchArchive$.setCacheHitset(h.id, h);
            this._hitsetMap.set(h.id, h);
        });
    }
}
